import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Route, Redirect, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';

export class AuthenticatedRoute extends Component {
    constructor(props) {
        super(props);
        this.checkSecurity = this.checkSecurity.bind(this);
    }

    checkSecurity() {
        return (
            this.props.isAuthenticated ?
                <Route component={this.props.component} /> :
                <Redirect to={{pathname: '/login', state: {from: this.props.location}}} />
        );
    }

    render() {
        return <Route render={this.checkSecurity} />;
    }
}

AuthenticatedRoute.propTypes = {
    location: PropTypes.object,
    component: PropTypes.any,
    isAuthenticated: PropTypes.bool,
};

const mapStateToProps = (state) => {
    return {
        isAuthenticated: state.auth.logged,
    };
};

export default withRouter(connect(mapStateToProps)(AuthenticatedRoute));
